import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule, routes} from './app-routing.module';
import { AppComponent, UploadInterceptor } from './app.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateInputsModule, TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { ErrorInterceptor } from '../app/helpers/error.interceptor';
import { AuthGuard } from './authentication/guards/auth-guard.service';
import { ToastrModule } from 'ngx-toastr';
import { MatSelectModule, MatDialogModule, MatInputModule, MatButtonModule, MatCardModule, MatDatepickerModule, MatNativeDateModule,MatRadioModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpConfigInterceptor } from './helpers/httpconfig.interceptor';
import { ErrorDialogService } from './error-dialog/errordialog.service';
import { ErrorDialogComponent } from './error-dialog/errordialog.component';
import {MatTabsModule} from '@angular/material/tabs';
import { DownloadDirective } from "./download.directive";
import { GridModule } from '@progress/kendo-angular-grid';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ErrorDialogComponent,
    DownloadDirective,

  //  ErrorpageComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DateInputsModule,
    InputsModule,
    MatSelectModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {useHash: true}),
    ToastrModule.forRoot({
      progressBar: true
    })
    
    // BotDetectCaptchaModule
  ],
  providers: [
    DatePipe,
    AuthGuard,   
    ErrorDialogService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
    //{ provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor,multi: true }
    //  { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
  entryComponents: [ErrorDialogComponent],
  bootstrap: [AppComponent]


})
export class AppModule { }
